import GenericWheel from './index'

const abundanceEngineExports = {
  GenericWheel
}

export default abundanceEngineExports
